import React from "react";
import { IconProps } from "@/components/Icon";
interface SmsIconProps extends Omit<IconProps, "children"> {}

export const SmsIcon = ({ ...props }: SmsIconProps) => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="12" fill="#0086C9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 5.69995C8.68654 5.69995 6.00024 8.38624 6.00024 11.7C6.00024 12.4969 6.15596 13.2591 6.43918 13.9564C6.46476 14.0194 6.47947 14.0558 6.48956 14.0826L6.49262 14.0909L6.49224 14.0938C6.48924 14.1159 6.48428 14.1461 6.47467 14.2037L6.11601 16.3557C6.09992 16.4521 6.08191 16.5599 6.07484 16.6535C6.06713 16.7556 6.06445 16.9181 6.13808 17.0898C6.22911 17.302 6.39822 17.4711 6.61044 17.5621C6.78212 17.6357 6.94456 17.6331 7.04667 17.6254C7.14032 17.6183 7.24816 17.6003 7.34454 17.5842L9.49647 17.2255C9.5541 17.2159 9.58428 17.211 9.60642 17.208L9.60927 17.2076L9.61756 17.2106C9.64442 17.2207 9.68078 17.2354 9.74377 17.261C10.4411 17.5442 11.2033 17.7 12.0002 17.7C15.314 17.7 18.0002 15.0137 18.0002 11.7C18.0002 8.38624 15.314 5.69995 12.0002 5.69995ZM8.40024 11.7C8.40024 11.2029 8.80319 10.8 9.30024 10.8C9.7973 10.8 10.2002 11.2029 10.2002 11.7C10.2002 12.197 9.7973 12.6 9.30024 12.6C8.80319 12.6 8.40024 12.197 8.40024 11.7ZM11.1002 11.7C11.1002 11.2029 11.5032 10.8 12.0002 10.8C12.4973 10.8 12.9002 11.2029 12.9002 11.7C12.9002 12.197 12.4973 12.6 12.0002 12.6C11.5032 12.6 11.1002 12.197 11.1002 11.7ZM14.7002 10.8C14.2032 10.8 13.8002 11.2029 13.8002 11.7C13.8002 12.197 14.2032 12.6 14.7002 12.6C15.1973 12.6 15.6002 12.197 15.6002 11.7C15.6002 11.2029 15.1973 10.8 14.7002 10.8Z"
        fill="white"
      />
    </svg>
  );
};
